<template>
  <div class="tags-list">
    <div class="setting-header v-center space-between px-3">
      <div class="setting-heading-box">
        <img class="btn-icon setting-icon" src="~@/assets/images/icons/tags-icon.svg" alt="" width="15px" />
        <h3 class="setting-name">
          Tags
        </h3>
        <p class="setting-subscript">Reusable labels for classification and filtering across entities</p>
      </div>
      <div class="v-center">
        <div class="tags_button">
          <button class="btn btn-black" :disabled="createButtonDisabled" @click="addNewTag" v-if="isTenantAdmin">
            Create Tag
          </button>
        </div>
      </div>
    </div>
    <div class="tags-list-container">
      <div class="tags-list-tag-types">
        <div v-for="(tagtype, index) in tagTypes" :key="tagtype.id" class="tags-list-type-pane" @click="selectTagType(tagtype, index)">
          <settings-bar
            :title="tagtype.name"
            :selected="selectedTagType.id === tagtype.id"
            :count="null"
          />
        </div>
      </div>
      <div class="custom-list-detail-pane">
        <div v-if="!selectedTagType.id" class="empty-state center">
          <p class="text-s">Select a tag type to view tags</p>
        </div>
        <div v-else-if="!displayList.length && !loading" class="empty-state center">
          <p class="text-s">No tags found for {{ selectedTagType.name }}</p>
        </div>
        <template v-else>
            <div v-if="loading" class="center loading-container">
      <loading-circle />
    </div>
    <div class ="tag-container" v-else>
        <list-row
          v-for="item in filteredList"
          :key="item.id"
          :item="item"
          :depth="0"
          :is-tenant-admin="isTenantAdmin"
          :selected-list-id="selectedTagType.id"
          :all-values="flatTagList"
          :expanded-state="expandedState"
          :active-path-set="activePathSet"
          :is-searching="false"
          :selected-item-id="selectedTagId"
          :row-clickable="true"
          :read-only="false"
          :fetch-children="fetchTagChildren"
          :save-edit-handler="saveTagEdit"
          :add-child-handler="saveTagChild"
          :always-show-chevron="true"
          :show-import-action="false"
          :show-delete-action="false"
          :show-abbreviation-field="true"
          :editing-row-id="editingRowId"
          :is-creating="isCreating"
          @select="handleTagSelect"
          @toggle-expand="handleToggleExpand"
          @children-loaded="handleChildrenLoaded"
          @edit-start="handleEditStart"
          @edit-end="handleEditEnd"
          @create-start="handleCreateStart"
          @create-end="handleCreateEnd"
        />
        </div>
        </template>
      </div>
      <!-- <div v-else>
      <list-detail
        :selected="selectedList"
        @update="getListDetails"
      />
    </div> -->
    </div>
    <modal :open="openCreateTagModal" @close="cancelCreateTag" :closeOnOutsideClick="true" title="Create New TAG">
      <div class="create-new-input s p-4" v-if="openCreateTagModal">
        <div class="input-group imp">
          <div v-if="checkRootLevelTag">
            <label>Creating a Root Level Tag for <b>{{ checkRootLevelTag }}</b></label>
          </div>
          <div v-else>
            <label>Creating Child Tag For: <b> {{ selectedTagName }} </b></label>
          </div>
          <label class="key">TAG Name:</label>
          <input v-model="value" class="searchInput input-group relative mt-1" :isEmpty="true" type="text" placeholder="Enter TAG Name" />
          <label class="key mt-2">Abbreviation:</label>
          <input v-model="abbreviatedValue" class="searchInput input-group relative mt-1" type="text" placeholder="Enter Abbreviation (optional)" />
        </div>
        <div class="flex flex-end py-3 l">
          <button @click="saveCreateTag" :disabled="EmptyInputError" class="btn">SAVE</button>
          <button @click="cancelCreateTag" class="btn btn-cancel mr-3">CANCEL</button>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import loadingCircle from '../../components/common/loadingCircle.vue'
import Modal from '../../components/common/modal.vue'
import { success, alert } from '@/plugins/notification'
import { displayrootTagName, createNewTag, rootTagName, ToUpdateTagName, checkTagName, GetChildLevelTags } from '@/api'
import config from '@/config'
import SettingsBar from '@/components/common/settingsBar.vue'
import ListRow from '@/components/settings/customLists/listRow.vue'

export default {
  data () {
    return {
      tagType: null,
      loading: false,
      displayList: [],
      tagIndexParents: [],
      value: '',
      abbreviatedValue: null,
      selectedTagName: '',
      selectedTagAbbreviatedName: '',
      openCreateTagModal: false,
      selectedTagType: {},
      selectedTagId: null,
      expandedState: {},
      syncingRoute: false,
      editingRowId: null,
      isCreating: false
    }
  },
  components: {
    loadingCircle,
    Modal,
    SettingsBar,
    ListRow
  },
  computed: {
    ...mapGetters(['user']),
    filteredList () { return this.displayList },
    createButtonDisabled () {
      return !this.selectedTagType.id
    },
    EmptyInputError () {
      return this.value.trim() === ''
    },
    isTenantAdmin () {
      return this.user.tenantLevelRole === 'ADMIN'
    },
    checkRootLevelTag () {
      return !this.selectedTagId && this.selectedTagType.name
    },
    tagTypes () {
      return [{ id: config.TAG_TYPE_MAP.MATERIAL, name: 'Material Tags' }, { id: config.TAG_TYPE_MAP.TASK, name: 'Task Tags' }, { id: config.TAG_TYPE_MAP.FORM, name: 'Form Tags' }]
    },
    selectedTagPathIds () {
      return this.tagIndexParents.slice(1).map(item => item.id)
    },
    activePathSet () {
      return [...new Set([...Object.keys(this.expandedState), ...this.selectedTagPathIds.map(String)])]
        .reduce((acc, id) => {
          acc[id] = true
          return acc
        }, {})
    },
    flatTagList () {
      const values = []
      const traverse = (items = []) => {
        items.forEach(item => {
          values.push(item)
          traverse(item.children || [])
        })
      }
      traverse(this.displayList)
      return values
    }
  },
  methods: {
    handleEditStart (rowId) {
      this.editingRowId = rowId
    },
    handleEditEnd (rowId = null) {
      if (rowId === null || this.editingRowId === rowId) {
        this.editingRowId = null
      }
    },
    handleCreateStart () {
      this.isCreating = true
    },
    handleCreateEnd () {
      this.isCreating = false
    },
    createTagNode (item, { children, childrenLoaded = false } = {}) {
      const { tags_aggregate: tagsAggregate, child_values_aggregate: childValuesAggregate, ...rest } = item
      const count = Array.isArray(children)
        ? children.length
        : (tagsAggregate?.aggregate?.count ?? childValuesAggregate?.aggregate?.count ?? 0)

      return {
        ...rest,
        children,
        _childrenLoaded: childrenLoaded,
        child_values_aggregate: {
          aggregate: { count }
        }
      }
    },
    findTagPath (items = [], id, path = []) {
      for (const item of items) {
        const nextPath = [...path, item]
        if (String(item.id) === String(id)) {
          return nextPath
        }
        const childPath = this.findTagPath(item.children || [], id, nextPath)
        if (childPath.length) {
          return childPath
        }
      }
      return []
    },
    updateSelectedPath (path = [], tagType = this.selectedTagType) {
      if (!tagType?.id) {
        this.tagIndexParents = []
        return
      }
      const typeIndex = this.tagTypes.findIndex(item => String(item.id) === String(tagType.id))
      this.tagIndexParents = [{
        id: tagType.id,
        index: typeIndex,
        name: tagType.name
      }, ...path.map(item => ({
        id: item.id,
        index: null,
        name: item.name,
        abbreviation: item.abbreviation
      }))]
    },
    syncTagMetadata (path = []) {
      const selectedTag = path[path.length - 1]
      this.selectedTagId = selectedTag?.id || null
      if (!selectedTag) {
        this.selectedTagName = ''
        this.selectedTagAbbreviatedName = ''
        return
      }
      this.selectedTagName = selectedTag.name
      this.selectedTagAbbreviatedName = selectedTag.abbreviation
    },
    updateExpandedState (path = []) {
      const nextExpandedState = {}
      path.slice(0, -1).forEach(item => {
        nextExpandedState[item.id] = true
      })
      this.expandedState = nextExpandedState
    },
    async fetchTagChildren (itemId, offset, limit) {
      const res = await GetChildLevelTags(itemId, this.tagType)
      return (res.tag || []).map(child => this.createTagNode(child))
    },
    handleChildrenLoaded ({ parentId, children }) {
      const path = this.findTagPath(this.displayList, parentId)
      const parent = path[path.length - 1]
      if (!parent) return
      this.$set(parent, 'children', children)
      this.$set(parent, '_childrenLoaded', true)
      if (!parent.child_values_aggregate) {
        this.$set(parent, 'child_values_aggregate', { aggregate: { count: children.length } })
      } else if (!parent.child_values_aggregate.aggregate) {
        this.$set(parent.child_values_aggregate, 'aggregate', { count: children.length })
      } else {
        this.$set(parent.child_values_aggregate.aggregate, 'count', children.length)
      }
    },
    updateRouteQuery ({ tagType = this.selectedTagType.id, tagId = this.selectedTagId } = {}) {
      const nextQuery = { ...this.$route.query }
      if (tagType) {
        nextQuery.tagType = String(tagType)
      } else {
        delete nextQuery.tagType
      }
      if (tagId) {
        nextQuery.tagId = String(tagId)
      } else {
        delete nextQuery.tagId
      }

      const currentTagType = this.$route.query.tagType ? String(this.$route.query.tagType) : null
      const currentTagId = this.$route.query.tagId ? String(this.$route.query.tagId) : null
      const nextTagType = nextQuery.tagType ? String(nextQuery.tagType) : null
      const nextTagId = nextQuery.tagId ? String(nextQuery.tagId) : null

      if (currentTagType === nextTagType && currentTagId === nextTagId) {
        return
      }

      this.syncingRoute = true
      this.$router.replace({ query: nextQuery }).finally(() => {
        this.syncingRoute = false
      })
    },
    async loadTagsByType (tagType) {
      this.loading = true
      this.tagType = tagType.id
      try {
        const res = await displayrootTagName(tagType.id)
        this.displayList = (res.tag || []).map(item => this.createTagNode(item))
      } catch (err) {
        console.log(err)
        this.displayList = []
      } finally {
        this.loading = false
      }
    },
    async selectTagType (tagType, index = null, { syncRoute = true, selectedTagId = null } = {}) {
      this.selectedTagType = tagType
      this.selectedTagId = null
      this.selectedTagName = ''
      this.selectedTagAbbreviatedName = ''
      this.updateSelectedPath([], { ...tagType, index })
      this.expandedState = {}
      await this.loadTagsByType(tagType)

      if (selectedTagId) {
        const path = this.findTagPath(this.displayList, selectedTagId)
        if (path.length) {
          this.applySelectedTagPath(path, { syncRoute })
          return
        }
      }

      if (syncRoute) {
        this.updateRouteQuery({ tagType: tagType.id, tagId: null })
      }
    },
    applySelectedTagPath (path = [], { syncRoute = true } = {}) {
      this.updateSelectedPath(path)
      this.syncTagMetadata(path)
      this.updateExpandedState(path)
      if (syncRoute) {
        this.updateRouteQuery()
      }
    },
    handleTagSelect (item) {
      const path = this.findTagPath(this.displayList, item.id)
      if (!path.length) return
      this.applySelectedTagPath(path)
    },
    handleToggleExpand ({ expanded, pathIds = [] }) {
      if (expanded) {
        const nextExpandedState = {}
        pathIds.forEach(pathId => {
          nextExpandedState[pathId] = true
        })
        this.expandedState = nextExpandedState
      } else {
        const nextExpandedState = {}
        pathIds.slice(0, -1).forEach(pathId => {
          nextExpandedState[pathId] = true
        })
        this.expandedState = nextExpandedState
      }
    },
    async syncSelectionFromRoute () {
      const routeTagType = this.$route.query.tagType
      const routeTagId = this.$route.query.tagId

      if (!routeTagType) {
        this.tagType = null
        this.selectedTagType = {}
        this.selectedTagId = null
        this.selectedTagName = ''
        this.selectedTagAbbreviatedName = ''
        this.displayList = []
        this.tagIndexParents = []
        this.expandedState = {}
        return
      }

      const tagType = this.tagTypes.find(item => String(item.id) === String(routeTagType))
      if (!tagType) return

      const shouldReload = String(this.selectedTagType.id) !== String(tagType.id)
      if (shouldReload) {
        await this.selectTagType(tagType, null, { syncRoute: false, selectedTagId: routeTagId })
        return
      }

      if (!routeTagId) {
        this.selectedTagId = null
        this.selectedTagName = ''
        this.selectedTagAbbreviatedName = ''
        this.updateSelectedPath([], tagType)
        this.expandedState = {}
        return
      }

      const path = this.findTagPath(this.displayList, routeTagId)
      if (path.length) {
        this.applySelectedTagPath(path, { syncRoute: false })
      }
    },
    addNewTag () {
      this.openCreateTagModal = true
    },
    cancelCreateTag () {
      this.value = ''
      this.abbreviatedValue = ''
      this.openCreateTagModal = false
    },
    async saveTagEdit ({ item, name, abbreviation }) {
      const value = name.trim().toUpperCase()
      const abbreviatedValue = abbreviation?.trim()?.toUpperCase() || null
      if (!value) return

      const body = {}
      if (value !== item.name?.toUpperCase()) {
        body.name = value
      }
      if ((abbreviatedValue || null) !== (item.abbreviation?.toUpperCase() || null)) {
        body.abbreviation = abbreviatedValue
      }
      if (!Object.keys(body).length) return

      const duplicateCheck = item.parent_id
        ? await checkTagName(value, item.parent_id, this.tagType, abbreviatedValue || '')
        : await rootTagName(value, this.tagType, abbreviatedValue || '')

      const hasDuplicate = (duplicateCheck.tag || []).some(existing => {
        const sameId = String(existing.id) === String(item.id)
        if (sameId) return false
        return existing.name === value || (abbreviatedValue && existing.abbreviation === abbreviatedValue)
      })

      if (hasDuplicate) {
        alert(abbreviatedValue ? 'Tag Name or Abbreviated Name Already exists' : 'Tag Name Already exists')
        const error = new Error('duplicate')
        error.silent = true
        throw error
      }

      await ToUpdateTagName(item.id, body, this.tagType)
      this.$set(item, 'name', value)
      this.$set(item, 'abbreviation', abbreviatedValue)
      if (String(this.selectedTagId) === String(item.id)) {
        this.selectedTagName = value
        this.selectedTagAbbreviatedName = abbreviatedValue
      }
      success('Tag updated successfully')
    },
    async saveTagChild ({ item, name, abbreviation, existingChildren }) {
      const value = name.trim().toUpperCase()
      const abbreviatedValue = abbreviation?.trim()?.toUpperCase() || null
      if (!value) return existingChildren

      const validation = await checkTagName(value, item.id, this.tagType, abbreviatedValue || '')
      const duplicate = (validation.tag || []).some(existing => {
        return existing.name === value || (abbreviatedValue && existing.abbreviation === abbreviatedValue)
      })
      if (duplicate) {
        alert(abbreviatedValue ? 'Tag Name or Abbreviated Name Already exists' : 'Tag Name Already exists')
        const error = new Error('duplicate')
        error.silent = true
        throw error
      }

      const response = await createNewTag(value, item.id, this.tagType, abbreviatedValue)
      const newChild = this.createTagNode(response?.insert_tag_one || {
        id: `temp-${Date.now()}`,
        name: value,
        abbreviation: abbreviatedValue,
        parent_id: item.id
      })
      success('New Tag Created successfully')
      return [...existingChildren, newChild]
    },
    saveCreateTag () {
      this.TagDataForRoot()
    },
    TagDataForRoot () {
      const value = this.value.toUpperCase()
      const abbreviatedValue = this.abbreviatedValue?.toUpperCase()
      rootTagName(value, this.tagType, abbreviatedValue).then((data) => {
        let nameExists = false
        let abbreviationExists = false
        for (const item of data.tag) {
          if (item.name === value) {
            nameExists = true
          }
          if (item.abbreviation === abbreviatedValue && item.abbreviation?.length) {
            abbreviationExists = true
          }
        }
        if (nameExists) {
          alert('Tag Name Already exists')
        }
        if (abbreviationExists) {
          alert('Abbreviated Name Already exists')
        }
        if (!nameExists && !abbreviationExists) {
          createNewTag(value, null, this.tagType, abbreviatedValue)
            .then((data) => {
              success('New Tag Created successfully')
              this.displayList.push(this.createTagNode(data?.insert_tag_one))
              this.handleTagSelect(data?.insert_tag_one)
              this.cancelCreateTag()
            })
            .catch(() => {
            })
        }
      })
    },
    keyPress (e) {
      if (this.EmptyInputError) {} else if (e instanceof KeyboardEvent && e.code === 'Enter' && this.openCreateTagModal) {
        this.saveCreateTag()
      }
    }
  },
  mounted () {
    if (!this.$route.query.tagType) {
      const initialTagType = this.tagTypes[0]
      this.$router.replace({ query: { ...this.$route.query, tagType: this.tagTypes[0].id } })
      this.selectTagType(initialTagType, null, { syncRoute: false, selectedTagId: this.$route.query.tagId })
    }
  },
  beforeDestroy () {
    document.body.removeEventListener('keydown', this.keyPress)
  },
  created () {
    document.body.addEventListener('keydown', this.keyPress)
    this.syncSelectionFromRoute()
  },
  watch: {
    '$route.query': {
      deep: true,
      handler () {
        if (this.syncingRoute) return
        this.syncSelectionFromRoute()
      }
    }
  }
}
</script>

<style scoped lang="scss">
.tag-container{
  gap:7px;
  min-width: 140px;
  // padding-top: 30px;
  max-height: calc(100vh - 187px);
  overflow: auto;
}
.create-new-input {
  width: 600px;
  max-height: 700px;
  overflow: auto;
  margin-right: 3px;
}
.error-text {
  color: red;
  padding-top: 12px;
}
.error-test-default{
  color: red;
  padding-top: 12px;
  visibility: hidden;
}
.btn {
  margin-right: 12px;
}
.tags_button{
  display: flex;
  justify-content: flex-end;
  gap: 7px;
  margin-bottom: 3px;
}
.tags-list {
  --tag-types-pane-width: 240px;
  height: stretch;
  &-container {
        height: calc(100vh - 168px);
      display: grid;
      grid-template-columns: var(--tag-types-pane-width) 1fr;
      gap: 10px;
      & .loading-container{
        height: stretch;
      }
      & .tag-container{
        height: 100%;
        overflow-y: auto;

      }
}
&-type-pane{
  cursor: pointer;
}
&-tag-types{
width: var(--tag-types-pane-width);
border-right: 1px solid var(--borderColor);
}
}
.custom-list-detail-pane {
  background: #fff;
}
.empty-state {
  height: 100%;
  min-height: 180px;
}
</style>
